import api from "../utils/axiosConfig";
import { USE_MOCK_DATA } from "../utils/mock";
import {
  GAME_ROOMS,
  GameInteraction,
  GameInteractionType,
} from "../utils/games";
import { dedupeInFlight } from "../utils/inFlight";

export interface GameHallItem {
  id?: string;
  code: string;
  image: string;
  name?: string;
  subtitle?: string;
  badge?: string;
  nameKey?: string;
  detailKey?: string;
  badgeKey?: string;
  href: string;
  available: boolean;
  interaction: GameInteractionType;
}

type ApiGame = {
  id: string;
  slug: string;
  name: string;
  subtitle?: string;
  badge?: string | null;
  tileImage?: string | null;
  isPlayable: boolean;
  interaction?: GameInteractionType;
};

const VISUALS: Record<string, { image: string; fallback?: (typeof GAME_ROOMS)[number] }> = {
  lotto: { image: "/assets/game-v6.webp", fallback: GAME_ROOMS[0] },
  craps: { image: "/assets/game-v5.webp" },
  "speed-draw": { image: "/assets/game-v5.webp", fallback: GAME_ROOMS[1] },
  "treasure-bonus": { image: "/assets/game-v4.webp", fallback: GAME_ROOMS[2] },
  "fortune-spin": { image: "/assets/game-v3.webp", fallback: GAME_ROOMS[3] },
  "poolball-game": { image: "/assets/game-v2.webp", fallback: GAME_ROOMS[4] },
  "super-cars-jackpot": { image: "/assets/game-v1.webp", fallback: GAME_ROOMS[5] },
};

const toGameHallItem = (game: ApiGame): GameHallItem => {
  const visual = VISUALS[game.slug] ?? { image: "/assets/game-v1.webp" };
  const fallback = visual.fallback;

  return {
    id: game.id,
    code: game.slug,
    image: game.tileImage || visual.image,
    name: game.name,
    subtitle: game.subtitle,
    badge: game.badge || (game.isPlayable ? "Open" : "Coming Soon"),
    nameKey: fallback?.nameKey,
    detailKey: fallback?.detailKey,
    badgeKey: fallback?.badgeKey,
    href: game.isPlayable ? "/game/bet" : "#",
    available: game.isPlayable,
    interaction:
      game.interaction ??
      fallback?.interaction ??
      (game.isPlayable ? GameInteraction.CLICKABLE : GameInteraction.DISABLED),
  };
};

export const getGames = async (): Promise<{ status: number; items: GameHallItem[] }> => {
  if (USE_MOCK_DATA) return { status: 1, items: GAME_ROOMS };

  const response = await dedupeInFlight(
    "GET /games",
    () => api.get<{ items: ApiGame[] }>("/games"),
  );
  return { status: 1, items: response.data.items.map(toGameHallItem) };
};
